/**
 * Created by rathompson on 10/13/23
 * File: MoveTenantPreviewTable.tsx
 * Project: cloud-mgmt-modules ©
 * ©
 */


import type { VFC } from 'react'
import V5TableWrapper from '../../../common/components/table/V5TableWrapper'
import { ConnectedTable, ConnectedTableLayout, TableProvider } from '@panwds/react-table'
import { useContext, useEffect, useMemo, useState } from 'react'
import { TABLE_HEADER_APPLICATIONS, TABLE_HEADER_DISPLAY_NAME, TABLE_HEADER_ROLES } from '../../constants/LabelConstants'
import type { IAM_AccessPolicy } from '../../../common/reducers/types/IAMReducer.types'
import { getMembers } from '../../../iam/components/identities/table/IdentitiesTable/utils'
import GlobalContext from '../../../common/context/GlobalContext'
import { safeSet } from '../../../common/utils/Utils'
import { Body, useIsMounted } from '@panwds/react-ui'
import RoleRenderer from '../../../iam/components/identities/table/cellRenderer/RoleRenderer'
import ApplicationsRenderer from '../../../iam/components/identities/table/cellRenderer/ApplicationsRenderer'

const MoveTenantPreviewTable: VFC<{
  policies: IAM_AccessPolicy[],
  loading: boolean
}> = ({ policies, loading }) => {

  const { treeReducer } = useContext(GlobalContext)
  const { sgKeyBy: tsgMap } = treeReducer
  const isMounted = useIsMounted()

  const [data, setData] = useState([])

  const columns = useMemo(() => {
    return [
      {
        id: 'display_name',
        Header: TABLE_HEADER_DISPLAY_NAME,
        accessor: 'display_name',
        Cell: ({ value }: any) => (
          <div className='cm-p-1 cm-w-full cm-h-full'>
            <Body size='lg' addClassName='cm-truncate'>{value}</Body>
          </div>
        )
      },
      {
        id: 'applications',
        Header: TABLE_HEADER_APPLICATIONS,
        Cell: ApplicationsRenderer
      },
      {
        id: 'roles',
        Header: TABLE_HEADER_ROLES,
        Cell: RoleRenderer
      }
    ]
  }, [])

  useEffect(() => {
    safeSet(setData, getMembers(policies, [], tsgMap), isMounted.current)
  }, [isMounted, policies, tsgMap])

  return (
    <V5TableWrapper>
      <TableProvider
        isLoading={loading}
        enableColumnOrder
        enableColumnSort
        enableResizeColumns
        enablePagination
        columns={columns}
        data={data}
      >
        <ConnectedTableLayout>
          <ConnectedTable/>
        </ConnectedTableLayout>
      </TableProvider>
    </V5TableWrapper>
  )
}

export default MoveTenantPreviewTable
